import React, { Fragment, useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import logoimg from '../../assets/images/logo.png';
import { Navigate } from 'react-router-dom';
import '../../styles/header.scss';
import UserService from '../../services/user';

function Header() {
    const [redirectToHome, setRedirectToHome] = useState(false);

    const logout = async () => {
        await UserService.logout();
        setRedirectToHome(true);
    }

    if (redirectToHome) {
        return (
            <Navigate to={{ pathname: "/" }} />
        )
    }

    return (
        <Fragment>
            <header className='header'>
                <Row xs={2} lg={3}>
                    <Col xs={10} lg={10}>
                        <a href="/ti" alt="Departamento de TI">
                            <img src={logoimg} className='logo' alt="Departamento de TI" />
                        </a>
                    </Col>
                    <Col xs={2} lg={2}>
                        <br/>
                        <br/>
                        <Button variant='danger' onClick={e => logout()}>Sair</Button>
                    </Col>
                </Row>
            </header>
        </Fragment >

    )
}

export default Header;